import { render, staticRenderFns } from "./TakipBilgileriForm.vue?vue&type=template&id=602a7859&scoped=true"
import script from "./TakipBilgileriForm.vue?vue&type=script&lang=ts"
export * from "./TakipBilgileriForm.vue?vue&type=script&lang=ts"
import style0 from "./TakipBilgileriForm.vue?vue&type=style&index=0&id=602a7859&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602a7859",
  null
  
)

export default component.exports